firebird.controller('meetingShowElectronCtrl', [
    '$scope',
    '$state',
    'meetingService',
    'helperService',
    function ($scope, $state, meetingService, helperService) {
        var self = this;

        self.title = '';
        self.getAppLogoURL = meetingService.getAppLogoURL;

        $scope.$on('camaro-detection-state-updated', openChromeTab);

        init();

        ////////////////////////

        function init() {
            self.title = meetingService.getTitle();
        }

        function openChromeTab(e, data) {
            if (helperService.isChrome() && data === 'failed') {
                $state.go('meeting-login', { templatePrefix: helperService.getRedesignPathPrefix() });
            }
        }
    }
]);
